// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"eE","speechCardBox":"eE","speech-img-box":"eF","speechImgBox":"eF","card-content":"eG","cardContent":"eG","card-src":"eH","cardSrc":"eH"};